import { View } from "@react-pdf/renderer";
import { ResumePDFText } from "components/Resume/ResumePDF/common";
import { TemplateEighteenPDFSectionPDF } from "./common";

export const Summary = ({
  heading,
  summary,
  themeColor,
}: {
  heading: string;
  summary: string;
  themeColor: string;
}) => {
  return (
    <TemplateEighteenPDFSectionPDF themeColor={themeColor} heading={heading}>
      <View>
        {summary && <ResumePDFText themeColor="black">{summary}</ResumePDFText>}
      </View>
    </TemplateEighteenPDFSectionPDF>
  );
};
